import zenObservable from 'zen-observable';

var Observable = zenObservable;

export default Observable;
export { Observable };
//# sourceMappingURL=bundle.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/apollo-link-batch-http/~/zen-observable-ts/lib/bundle.esm.js
// module id = 343
// module chunks = 0